import zhcn from './zh-cn.messages.json';
import zhtw from './zh-tw.messages.json';
import ms from './ms.messages.json';
import id from './id.messages.json';
import vi from './vi.messages.json';
import th from './th.messages.json';
import ta from './ta.messages.json';
import tl from './tl.messages.json';
import my from './my.messages.json';
import ne from './ne.messages.json';
import tpi from './tpi.messages.json';
import bn from './bn.messages.json';
import pt from './pt.messages.json';

export const langs = {
  'zh-cn': { ...zhcn },
  'zh-tw': { ...zhtw },
  ms: { ...ms },
  id: { ...id },
  vi: { ...vi },
  th: { ...th },
  ta: { ...ta },
  tl: { ...tl },
  my: { ...my },
  ne: { ...ne },
  tpi: { ...tpi },
  bn: { ...bn },
  pt: { ...pt },
};
